var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import cx from 'clsx';
import { labelStyles, disabledStyles } from './InputLabel.css';
export const InputLabel = React.forwardRef(function InputLabel(_a, ref) {
    var { children, className, isDisabled } = _a, rest = __rest(_a, ["children", "className", "isDisabled"]);
    if (ref === void 0) { ref = null; }
    return (_jsx("label", Object.assign({ className: cx(labelStyles, isDisabled && disabledStyles, className) }, rest, { ref: ref, children: children })));
});
